import { SideBarDef } from 'ag-grid-community';

export const sideBar = {
    toolPanels: [
        {
            id: 'columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            width: 260,
            toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnSelectAll: true,
                suppressColumnExpandAll: true,
            },
        },
    ],
} as SideBarDef;
